import { render } from "./NewPrediction.vue?vue&type=template&id=6611c652&ts=true"
import script from "./NewPrediction.vue?vue&type=script&lang=ts"
export * from "./NewPrediction.vue?vue&type=script&lang=ts"

import "./NewPrediction.vue?vue&type=style&index=0&id=6611c652&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__